import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useConfirmPasswordChangeMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';

interface Args {
  oldPassword: string;
  newPassword: string;
  otpToken: string;
}

export const useConfirmPasswordChange = () => {
  const [handle, { data, loading, error: apolloError }] =
    useConfirmPasswordChangeMutation();

  const error = useError(apolloError);

  return {
    data,
    loading,
    error,
    confirmPasswordChange: useCallback(
      async (args: Args) => {
        const res = await handle({ variables: args });
        return res.data?.confirmPasswordChange;
      },
      [handle]
    ),
  };
};
